module.exports = __webpack_public_path__ + "static/media/CedricLetsch.ec990b2f.jpg";